import { useRef } from 'react';
import useLdFlags from '../../hooks/useLdFlags';
import { ENABLE_FASTIFY_API_FLAG } from '../../utils/constants';

export const ENABLE_FASTIFY_API_DEFAULT = false;

function defaultValue() {
  if (process.env.REACT_APP_ENABLE_FASTIFY_API_DEFAULT === 'true') return true;
  if (process.env.REACT_APP_ENABLE_FASTIFY_API_DEFAULT === 'false') return false;
  return ENABLE_FASTIFY_API_DEFAULT;
}

export default function useEnableFastifyApi() {
  const { ldFlags } = useLdFlags();
  // Latched per mount: a LaunchDarkly value resolving mid-session must not swap an adapter's
  // returned tuple under a live component — mount effects ([]-dep) that fired one branch's
  // execute never refire for the other, leaving data undefined and the page stuck. A flag flip
  // applies on the next mount (navigation/reload), which is how the killswitch is operated
  // anyway. In practice App.js warms the flags cache at startup, so post-initial mounts read
  // the real flag synchronously (cache-first) and latch the right branch immediately.
  const latchedRef = useRef(null);
  if (latchedRef.current === null) {
    latchedRef.current = ldFlags?.[ENABLE_FASTIFY_API_FLAG] ?? defaultValue();
  }
  return latchedRef.current;
}
